export type DownloadJob = {
  id: string;
  filename: string;
  progress: number | null;
  cancel(): void;
};

type Listener = () => void;

let jobs: DownloadJob[] = [];
const listeners = new Set<Listener>();

const emit = (): void => {
  for (const listener of listeners) {
    listener();
  }
};

export const subscribeDownloadJobs = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const getDownloadJobs = (): DownloadJob[] => jobs;

export const beginDownloadJob = (
  filename: string,
  cancel: () => void
): {
  setProgress(progress: number | null): void;
  finish(): void;
} => {
  const id = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  jobs = [...jobs, { id, filename, progress: null, cancel }];
  emit();

  return {
    setProgress(progress) {
      const index = jobs.findIndex((item) => item.id === id);
      if (index === -1 || jobs[index].progress === progress) {
        return;
      }
      const next = [...jobs];
      next[index] = { ...jobs[index], progress };
      jobs = next;
      emit();
    },
    finish() {
      if (!jobs.some((item) => item.id === id)) {
        return;
      }
      jobs = jobs.filter((item) => item.id !== id);
      emit();
    },
  };
};
